







import Vue from 'vue'
export default Vue.extend({
  name: 'wikiTableTreeTitle',
  props: {
    row: {}
  }
})
